import type { PageCallout } from '../types/route-types';

/**
 * The page's optional notice under the H1 (`page_seo.callout`, prod fixes 2026-10-02 FIX-6), or null.
 *
 * Content data from the SSR build, so it is checked rather than trusted: text must be a non-blank string, and a
 * link is kept only when its text occurs in the callout and its href is an absolute https URL (the notice links
 * out, e.g. to the Ruffle player). Anything else is dropped, never rendered half-formed.
 */
export function pageCalloutOf(pageSeo: unknown): PageCallout | null {
    const c = (pageSeo as { callout?: unknown } | null | undefined)?.callout as Partial<PageCallout> | undefined;
    if (!c || typeof c !== 'object' || typeof c.text !== 'string' || !c.text.trim()) return null;
    const text = c.text.replace(/\s+/g, ' ').trim();
    const l = c.link as Partial<{ text: string; href: string }> | undefined;
    const link = l && typeof l.text === 'string' && l.text && typeof l.href === 'string'
        && /^https:\/\/[^\s"'<>]+$/.test(l.href) && text.includes(l.text)
        ? { text: l.text, href: l.href }
        : undefined;
    return link ? { text, link } : { text };
}
